import { particleAuth, AuthType } from "@particle-network/auth-core";
import {
  Ethereum,
  Avalanche,
  AvalancheTestnet,
} from "@particle-network/chains";
import { walletEntryPlugin, EntryPosition } from "@particle-network/wallet";

export default function () {
  if (import.meta.env.VITE_AUTH_PROVIDER === "privy") return;
  particleAuth.init({
    projectId: import.meta.env.VITE_PN_PROJECT_ID,
    clientKey: import.meta.env.VITE_PN_CLIENT_KEY,
    appId: import.meta.env.VITE_PN_APP_ID,
    chains: [AvalancheTestnet, Avalanche],
  });

  // walletEntryPlugin.init(
  //   {
  //     projectId: import.meta.env.VITE_PN_PROJECT_ID,
  //     clientKey: import.meta.env.VITE_PN_CLIENT_KEY,
  //     appId: import.meta.env.VITE_PN_APP_ID,
  //   },
  //   {
  //     visible: false,
  //     themeType: "dark",
  //     position: EntryPosition.MC,
  //     topMenuType: "close",
  //     customStyles: {
  //       supportChains: [AvalancheTestnet, Avalanche],
  //     },
  //   }
  // );
}
